<template>
  <div>
    <b-row v-if="itemSettings">
      <b-col lg="6" md="6" sm="12">
        <legend>
          <strong>{{ $t('item') }} {{ $t('settings') }}</strong>
        </legend>

        <b-form-group
          horizontal
          :label="$t('hourlyRate')"
          label-for="hourlyRate"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <InputNumber
            v-model="itemSettings.hourlyRate"
            mode="decimal"
            :minFractionDigits="2"
            :maxFractionDigits="2"
            :placeholder="$t('hourlyRate')"
            suffix=" €/h"
            locale="de-DE"
            class="w-100"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('margin')"
          label-for="margin"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <InputNumber
            v-model="itemSettings.margin"
            mode="decimal"
            :minFractionDigits="1"
            :maxFractionDigits="2"
            :placeholder="$t('margin')"
            suffix=" %"
            locale="de-DE"
            class="w-100"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('generalBusinessCosts')"
          label-for="generalBusinessCosts"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <InputNumber
            v-model="itemSettings.generalBusinessCosts"
            mode="decimal"
            :minFractionDigits="1"
            :maxFractionDigits="2"
            :placeholder="$t('generalBusinessCosts')"
            suffix=" %"
            locale="de-DE"
            class="w-100"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('profitMargin')"
          label-for="profitMargin"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <InputNumber
            v-model="itemSettings.profitMargin"
            mode="decimal"
            :minFractionDigits="1"
            :maxFractionDigits="2"
            :placeholder="$t('profitMargin')"
            suffix=" %"
            locale="de-DE"
            class="w-100"
          />
        </b-form-group>
      </b-col>
      <b-col lg="6" md="6" sm="12"> </b-col>
    </b-row>

    <b-row>
      <b-col lg="12" md="12" sm="12">
        <div class="button-bar">
          <div class="button-grid">
            <div class="alert-container">
              <b-alert show v-if="getFlashMessage.message" :variant="getFlashMessage.type">
                <span v-html="getFlashMessage.message" />
              </b-alert>
            </div>
            <div><Spinner class="spinner" v-if="isLoading" :size="25" /></div>
            <div>
              <b-button :disabled="isLoading" @click="saveSettings" variant="bg">{{
                $t('save')
              }}</b-button>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Spinner from '@/components/Spinner.vue';
import InputNumber from 'primevue/inputnumber';

export default {
  name: 'SettingsItem',
  components: {
    Spinner,
    InputNumber,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['getFlashMessage', 'isLoading', 'getItemSettings']),
    itemSettings() {
      return this.getItemSettings;
    },
  },
  methods: {
    ...mapActions(['fetchSettingsByCategory', 'updateSettings']),

    async saveSettings() {
      try {
        const result = await this.updateSettings({
          category: 'ITEM',
          settings: this.itemSettings,
        });
      } catch (error) {
        console.error('Error updating settings:', error);
      }
    },
  },
  async mounted() {
    try {
      const settings = await this.fetchSettingsByCategory('ITEM');
    } catch (error) {
      console.error('Error loading settings:', error);
    }
  },
};
</script>

<style scoped lang="scss">
.button-bar {
  .button-grid {
    display: flex;
    gap: 0.75rem;
    flex-flow: row wrap;
    align-items: right;
    justify-content: right;
    align-content: flex-end;
    background: #f5f5f5;
    padding: 1rem 1rem 0.75rem 1rem;
  }
}
</style>
